import tmhRequest from '@/config/tmhRequest'

export default {
    searchListConsumeMemberStatusGradeReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchlistconsumememberstatusgradereport',
            method: 'post',
            data: data,
        })
    },
    searchMemberAnalysisReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportConsumeMemberStatusGradeReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/exportconsumememberstatusgradereport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/consumememberstatusgradereport.js